import { useEffect, useState } from "react"

import {
    Box,
    Typography,
} from '@mui/material';

import { useReportContext } from "../../../context/ReportContext";

export function ReportBasicFilters({
    reportType,
    children
}) {

    const {
        t,
        // formik,
    } = useReportContext()

    // const { values, errors, touched, handleChange, setFieldValue, handleSubmit } = formik;

    return (
        <Box>
            <Box
                sx={{
                    mb: 1
                }}
            >
                <Typography
                    variant="h6"
                >
                    {t("basicSearch")}
                </Typography>
                <Typography
                    variant="subtitle2"
                >
                    {t("filterDataForBasicInformation")}
                </Typography>

                {/* <BasicFilterSalesOrder /> */}

                {children}

            </Box>

        </Box>
    )
}


export function ReportAdvancedFilters({
    reportType,
    children
}) {

    const {
        t,
        // formik
    } = useReportContext()

    // const { values, errors, touched, handleSubmit, handleChange, setFieldValue } = formik;

    return (
        <Box>
            <Box
                sx={{
                    mb: 1
                }}
            >
                <Typography
                    variant="h6"
                >
                    {t("advancedFilter")}
                </Typography>
                <Typography
                    variant="subtitle2"
                >
                    {t("filterDataForAdvancedInformation")}
                </Typography>

                {/* <AdvancedFilterSalesOrder /> */}

                {children}

            </Box>

        </Box>
    )
}